import React, { useCallback } from 'react';

import { FeatureListContentfulModel } from '../../api/models/FeatureList';
import FeatureListEntry from '../../molecules/featureListEntry/featureList.entry';
import FeatureListConfetti from 'organisms/featureList/featureList.confetti'

export interface FeaturesProps {
  features: FeatureListContentfulModel['contentfulchildren'];
  removeConfetti?: boolean;
  invert?: boolean;
}

const Features = ({ features, removeConfetti, invert }: FeaturesProps): JSX.Element => {
  const getTextOrientation = useCallback((index: number) => invert ? (index % 2 ? 'right' : 'left') : (index % 2 ? 'left' : 'right'), [ invert ])

  return (
    <>
      {
        !removeConfetti && <FeatureListConfetti />
      }
      {
        features.map((feature, index) => (
          <FeatureListEntry
            key={index}
            textOrientation={getTextOrientation(index)}
            title={feature.title}
            description={feature.description}
            image={feature.image}
            mobileImage={feature.mobileImage}
          />
        ))
      }
    </>
  )
}

export default Features;
